module.exports = __webpack_public_path__ + "img/car_07.eecab0d0.jpg";